// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ProfileSetup_profileSetupWrapper__WSNMc {
  padding: 1rem;
  max-width: 1050px;
  margin: auto;
}
.ProfileSetup_profileSetupWrapper__WSNMc .ProfileSetup_phoneInputStyle__QpF6K {
  width: 100%;
}
.ProfileSetup_profileSetupWrapper__WSNMc .ProfileSetup_phoneInputStyle__QpF6K input {
  width: 100%;
  border-radius: 5px;
}`, "",{"version":3,"sources":["webpack://./src/component/pages/service-provider-admin/auth/profile-setup/ProfileSetup.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,iBAAA;EACA,YAAA;AACF;AAAE;EACE,WAAA;AAEJ;AADI;EACE,WAAA;EACA,kBAAA;AAGN","sourcesContent":[".profileSetupWrapper {\n  padding: 1rem;\n  max-width: 1050px;\n  margin: auto;\n  .phoneInputStyle {\n    width: 100%;\n    input {\n      width: 100%;\n      border-radius: 5px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"profileSetupWrapper": `ProfileSetup_profileSetupWrapper__WSNMc`,
	"phoneInputStyle": `ProfileSetup_phoneInputStyle__QpF6K`
};
export default ___CSS_LOADER_EXPORT___;
